module.exports = __webpack_public_path__ + "img/451024.3727f6eb.png";